import axios from "../../api/axiosInstance";
import { STATUS, getProjectId, extractErrorInfo } from "./sharedfunction";

export async function saveLabel({ labelName } = {}) {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    if (!labelName || labelName.trim().length === 0) {
      return {
        status: STATUS.ERROR,
        error: "Label name is required",
      };
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${projectId}/labels/save`,
      { labelName },
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error saving label:", error);
    return extractErrorInfo(error);
  }
}

export async function getAllLabels() {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${projectId}/labels/getAll`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching labels:", error);
    return extractErrorInfo(error);
  }
}

